export enum Systems {
    CIS = 'CIS',
    DESK = 'DESK',
}
